<template>
  <message-component v-if="expiredCode" :level="'warning'">
    <translate>The code in the link has expired. Please, make a request to reset your password again.</translate>
  </message-component>
  <div v-else class="confirmation-form">
    <div class="columns is-multiline">
      <div class="column is-12">
        <title-component
          :size="3"
          :lineSeparator="'under'"
          v-translate>
          Please choose a password
        </title-component>
        <template v-if="formDescriptors && formDatas">
          <form-component
            v-for="formDescriptor in formDescriptors"
            :formDescriptor="formDescriptor"
            :formData="getFormDataForDescriptor(formDescriptor)"
            :key="formDescriptor.id">
          </form-component>
        </template>
        <transition
          name="fade"
          appear
          appear-active-class="animated fadeIn"
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
          :duration="{ enter: 200, leave: 200 }">
          <div v-if="mixin.error" class="notification is-danger">
            {{ mixin.error }}
          </div>
        </transition>
        <!-- Buttons -->
        <div class="field">
          <p class="control">
            <submit-btn-component class="is-primary" ref="enterButton" @submit="resetPassword" v-translate>Submit</submit-btn-component>
          </p>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import { mapActions, mapMutations, mapState } from 'vuex'
  import FormComponent from '../form/FormComponent'
  import { API_APPS } from '@/api/config'
  import TitleComponent from '../layout/TitleComponent.vue'
  import SubmitBtnComponent from '@/components/layout/utility/SubmitBtnComponent.vue'
  import { onKeyEnterMixin, formHandlerMixin } from '@/mixins/mixins'
  import AuthUser from '@/classes/auth/AuthUser'
  import Status from '@/classes/http/Status'
  import MessageComponent from '@/components/layout/utility/MessageComponent'

  export default {
    name: 'reset-password-confirmation-form-component',
    mixins: [onKeyEnterMixin, formHandlerMixin],
    data () {
      return {
        expiredCode: false
      }
    },
    props: {
      code: {
        type: String,
        required: true
      }
    },
    components: {
      TitleComponent,
      FormComponent,
      SubmitBtnComponent,
      MessageComponent
    },
    computed: {
      ...mapState({
        formDescriptors: state => state.authModule.formDescriptors,
        formDatas: state => state.authModule.formDatas
      })
    },
    methods: {
      ...mapMutations([
        'setAuthUser'
      ]),
      ...mapActions([
        'setupResetPasswordConfirmationForm',
        'saveResetPasswordConfirmationForm',
        'clearData'
      ]),
      resetPassword (btn) {
        let requestData = {
          formDatas: this.formDatas,
          code: this.code
        }
        this.submitRequest = this.saveResetPasswordConfirmationForm
        this.submitForm(requestData, btn, this.resetPasswordCallback)
      },
      resetPasswordCallback (response) {
        this.setAuthUser(response.data)
        if (AuthUser.isAdministrator()) {
          window.location.replace(API_APPS.ADMINISTRATOR + '/')
        } else if (AuthUser.isAuditor()) {
          window.location.replace(API_APPS.AUDITOR + '/')
        } else if (AuthUser.isCustomer()) {
          window.location.replace(API_APPS.CUSTOMER + '/')
        } else if (AuthUser.isManager()) {
          window.location.replace(API_APPS.MANAGER + '/')
        } else if (AuthUser.isHR()) {
          window.location.replace(API_APPS.HR + '/')
        }
      }
    },
    mounted () {
      this.setupResetPasswordConfirmationForm(this.code).catch((err) => {
        if (err.response.status === Status.NOT_FOUND) {
          this.expiredCode = true
        } else {
          this.handleError(err)
        }
      })
    },
    beforeDestroy () {
      this.clearData()
    }
  }
</script>
